import "normalize.css";
import "./src/assets/global.css";

import { WrapPageElement } from "./src";

export const wrapPageElement = WrapPageElement;

export const shouldUpdateScroll = () => false;
